var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor-page" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c(
          "div",
          { staticClass: "header-left" },
          [
            _c(
              "a-button",
              { attrs: { icon: "arrow-left" }, on: { click: _vm.goBack } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.back") || "Back") +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.isEditMode
                      ? _vm.$t("chatbotv2.editBlock") || "Edit Block"
                      : _vm.$t("chatbotv2.createBlock") || "Create Block"
                  ) +
                  "\n            "
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-actions" },
          [
            !_vm.isPublishedView
              ? _c(
                  "a-button",
                  {
                    attrs: { loading: _vm.saving, type: "default" },
                    on: { click: _vm.saveDraft },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("chatbotv2.saveDraft") || "Save Draft") +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isEditMode &&
            _vm.block &&
            _vm._.get(_vm.block, "draftVersion", false) &&
            !_vm.isPublishedView
              ? _c(
                  "a-button",
                  {
                    attrs: { type: "primary", loading: _vm.publishing },
                    on: { click: _vm.publishNow },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("chatbotv2.publish") || "Publish") +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isPublishedView
              ? _c(
                  "a-tag",
                  {
                    staticStyle: {
                      margin: "0",
                      padding: "8px 16px",
                      "font-size": "14px",
                    },
                    attrs: { color: "green" },
                  },
                  [
                    _c("a-icon", { attrs: { type: "lock" } }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("chatbotv2.readOnlyMode")) +
                        "\n            "
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "editor-content" },
        [
          _vm.isEditMode && _vm.block
            ? _c(
                "div",
                { staticClass: "version-tabs-wrapper" },
                [
                  _c(
                    "a-tabs",
                    {
                      attrs: { type: "card" },
                      on: { change: _vm.onVersionTabChange },
                      model: {
                        value: _vm.activeVersionTab,
                        callback: function ($$v) {
                          _vm.activeVersionTab = $$v
                        },
                        expression: "activeVersionTab",
                      },
                    },
                    [
                      _c("a-tab-pane", { key: "draft" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              gap: "4px",
                            },
                            attrs: { slot: "tab" },
                            slot: "tab",
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: { "font-size": "16px" },
                              },
                              [_vm._v("edit")]
                            ),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("chatbotv2.draft")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-tab-pane",
                        {
                          key: "published",
                          attrs: { disabled: !_vm.block.publishedVersion },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                gap: "4px",
                              },
                              attrs: { slot: "tab" },
                              slot: "tab",
                            },
                            [
                              _c(
                                "i",
                                {
                                  staticClass: "material-icons",
                                  staticStyle: { "font-size": "16px" },
                                },
                                [_vm._v("check_circle")]
                              ),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("chatbotv2.published")) +
                                  "\n                        "
                              ),
                              !_vm.block.publishedVersion
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#999",
                                        "font-size": "12px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "(" +
                                          _vm._s(
                                            _vm.$t("chatbotv2.notPublished")
                                          ) +
                                          ")"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-form",
            {
              attrs: {
                form: _vm.form,
                "label-col": { span: 24 },
                "wrapper-col": { span: 24 },
              },
            },
            [
              _c(
                "div",
                { staticClass: "section" },
                [
                  _c("h3", [
                    _vm._v(
                      _vm._s(_vm.$t("chatbotv2.basicInfo") || "Basic Info")
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: _vm.$t("chatbotv2.blockName") || "Block Name",
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          size: "large",
                          disabled: _vm.isPublishedView,
                          placeholder:
                            _vm.$t("chatbotv2.enterBlockName") ||
                            "Enter block name",
                        },
                        model: {
                          value: _vm.formData.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "name", $$v)
                          },
                          expression: "formData.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: _vm.$t("chatbotv2.description") || "Description",
                      },
                    },
                    [
                      _c("a-textarea", {
                        attrs: {
                          rows: 3,
                          size: "large",
                          disabled: _vm.isPublishedView,
                          placeholder:
                            _vm.$t("chatbotv2.enterDescription") ||
                            "Enter description",
                        },
                        model: {
                          value: _vm.formData.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "description", $$v)
                          },
                          expression: "formData.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: _vm.$t("chatbotv2.icon") || "Icon",
                              },
                            },
                            [
                              _c("MaterialIconPicker", {
                                attrs: { disabled: _vm.isPublishedView },
                                model: {
                                  value: _vm.formData.icon,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "icon", $$v)
                                  },
                                  expression: "formData.icon",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label:
                                  _vm.$t("chatbotv2.category") || "Category",
                              },
                            },
                            [
                              _c(
                                "a-auto-complete",
                                {
                                  attrs: {
                                    size: "large",
                                    disabled: _vm.isPublishedView,
                                    "data-source": _vm.filteredCategoryLabels,
                                    placeholder:
                                      _vm.$t(
                                        "chatbotv2.selectOrTypeCategory"
                                      ) || "Select or type category",
                                    "filter-option": function (input, option) {
                                      return (
                                        option
                                          .toUpperCase()
                                          .indexOf(input.toUpperCase()) !== -1
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.category,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "category", $$v)
                                    },
                                    expression: "formData.category",
                                  },
                                },
                                [
                                  _c(
                                    "a-input",
                                    {
                                      attrs: { size: "large", allowClear: "" },
                                    },
                                    [
                                      _c("a-icon", {
                                        staticStyle: {
                                          color: "rgba(0,0,0,.25)",
                                        },
                                        attrs: { slot: "prefix", type: "tag" },
                                        slot: "prefix",
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: _vm.$t("chatbotv2.tags") || "Tags",
                              },
                            },
                            [
                              _c("a-select", {
                                attrs: {
                                  mode: "tags",
                                  size: "large",
                                  disabled: _vm.isPublishedView,
                                  placeholder:
                                    _vm.$t("chatbotv2.addTags") || "Add tags",
                                },
                                model: {
                                  value: _vm.formData.tags,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "tags", $$v)
                                  },
                                  expression: "formData.tags",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "section" }, [
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("chatbotv2.javascriptCode") || "JavaScript Code"
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "code-editor-wrapper" }, [
                  _c("div", { staticClass: "code-editor-header" }, [
                    _c("div", { staticClass: "tips" }, [
                      _c(
                        "div",
                        { staticClass: "tip" },
                        [
                          _c("md-icon", [_vm._v("info")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.blockJsDesc"))),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tip" },
                        [
                          _c("md-icon", [_vm._v("warning")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("chatbotv2.jsSecurityNotice"))
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isPublishedView
                        ? _c(
                            "div",
                            {
                              staticClass: "tip",
                              staticStyle: { color: "#52c41a" },
                            },
                            [
                              _c("md-icon", [_vm._v("lock")]),
                              _vm._v(" "),
                              _c("span", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "chatbotv2.publishedVersionReadOnly"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "actions" },
                      [
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-right": "10px" },
                            attrs: { type: "primary" },
                            on: { click: _vm.toggleFullScreen },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: {
                                  "font-size": "15px",
                                  "margin-right": "5px",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.isFullScreen
                                        ? "fullscreen_exit"
                                        : "fullscreen"
                                    ) +
                                    "\n                                "
                                ),
                              ]
                            ),
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.isFullScreen
                                    ? _vm.$t("chatbotv2.exitFullScreen")
                                    : _vm.$t("chatbotv2.fullScreen")
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.isPublishedView
                          ? _c(
                              "a-button",
                              {
                                staticClass: "ai-assistant-btn",
                                attrs: { type: "primary" },
                                on: { click: _vm.showPromptWizard },
                              },
                              [
                                _c("img", {
                                  staticStyle: { "margin-right": "5px" },
                                  attrs: {
                                    src: "/static/img/copilot.png",
                                    width: "15",
                                    height: "15",
                                  },
                                }),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t("chatbotv2.supsisAssistant")
                                    ) +
                                    "\n                            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "code-editor" }, [
                    _c("div", { staticClass: "available-libraries" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.availableLibraries"))),
                      ]),
                      _vm._v(" "),
                      _c("code", [_vm._v("moment")]),
                      _vm._v(", "),
                      _c("code", [_vm._v("lodash (_)")]),
                      _vm._v(", "),
                      _c("code", [_vm._v("axios (HTTP client)")]),
                      _vm._v(",\n                            "),
                      _c("code", [_vm._v("OpenAI")]),
                      _vm._v(", "),
                      _c("code", [_vm._v("JSDOM")]),
                      _vm._v(", "),
                      _c("code", [_vm._v("validator")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "available-variables" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.availableVariables"))),
                      ]),
                      _vm._v(" "),
                      _c("code", [_vm._v("chatbot.readAttribute")]),
                      _vm._v(", "),
                      _c("code", [_vm._v("chatbot.sendMessage")]),
                      _vm._v(",\n                            "),
                      _c("code", [_vm._v("chatbot.setAttributes")]),
                      _vm._v(", "),
                      _c("code", [_vm._v("supsis.users")]),
                      _vm._v(",\n                            "),
                      _c("code", [_vm._v("supsis.contact")]),
                      _vm._v(
                        ", ve daha fazlası (chatbot. veya supsis. yazarak tüm\n                            metodları görebilirsiniz)\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "attribute-help" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.parameters")) + ":"),
                      ]),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("chatbotv2.parametersAutoAvailable")) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.formData.parameters.length > 0
                      ? _c("div", { staticClass: "parameter-usage-info" }, [
                          _c(
                            "div",
                            { staticClass: "info-header" },
                            [
                              _c("a-icon", { attrs: { type: "info-circle" } }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("chatbotv2.definedParametersUsage")
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "param-list" },
                            _vm._l(_vm.formData.parameters, function (param) {
                              return _c(
                                "div",
                                {
                                  key: param.name,
                                  staticClass: "param-usage-item",
                                },
                                [
                                  _c("code", { staticClass: "param-var" }, [
                                    _vm._v(_vm._s(param.name)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "param-desc" }, [
                                    _vm._v(
                                      _vm._s(param.label) +
                                        " (" +
                                        _vm._s(param.type) +
                                        ")"
                                    ),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "usage-examples" }, [
                            _c("div", { staticClass: "example-item" }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("chatbotv2.directUsage"))),
                              ]),
                              _vm._v(" "),
                              _c("code", [
                                _vm._v(
                                  "const value = " +
                                    _vm._s(
                                      _vm.$_.get(
                                        _vm.formData,
                                        "parameters[0].name",
                                        "parameterName"
                                      )
                                    ) +
                                    ";"
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "example-item" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("chatbotv2.readAllParameters"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("code", [
                                _vm._v(
                                  "chatbot.readAttribute('block.{blockId}.*')"
                                ),
                              ]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "param-injection-notice" },
                      [
                        _c("a-icon", {
                          attrs: {
                            type: "bulb",
                            theme: "twoTone",
                            "two-tone-color": "#faad14",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "notice-content" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("chatbotv2.parametersAutoInjected"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("chatbotv2.parametersAutoInjectedDesc")
                              )
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "monaco-editor-container",
                      class: { "fullscreen-editor": _vm.isFullScreen },
                      attrs: { id: "custom-block-editor-monaco" },
                    }),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section" }, [
                _c("h3", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("chatbotv2.parameters") || "Parameters") +
                      "\n                    "
                  ),
                  !_vm.isPublishedView
                    ? _c(
                        "div",
                        { staticClass: "param-actions" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "link", icon: "plus" },
                              on: { click: _vm.addParameter },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("chatbotv2.addParameter")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: { type: "link", icon: "import" },
                              on: { click: _vm.showImportJsonSchema },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("chatbotv2.importJsonSchema")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "parameters-builder" },
                  _vm._l(_vm.formData.parameters, function (param, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "parameter-card" },
                      [
                        _c(
                          "div",
                          { staticClass: "param-header" },
                          [
                            _c("span", { staticClass: "param-number" }, [
                              _vm._v("#" + _vm._s(index + 1)),
                            ]),
                            _vm._v(" "),
                            !_vm.isPublishedView
                              ? _c(
                                  "a-button",
                                  {
                                    attrs: {
                                      type: "danger",
                                      size: "small",
                                      icon: "delete",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeParameter(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t("message.delete") || "Delete"
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "param-row" },
                          [
                            _c("a-input", {
                              staticStyle: { width: "180px" },
                              attrs: {
                                disabled: _vm.isPublishedView,
                                placeholder:
                                  _vm.$t("chatbotv2.parameterName") ||
                                  "Parameter name (variable)",
                              },
                              model: {
                                value: param.name,
                                callback: function ($$v) {
                                  _vm.$set(param, "name", $$v)
                                },
                                expression: "param.name",
                              },
                            }),
                            _vm._v(" "),
                            _c("a-input", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                disabled: _vm.isPublishedView,
                                placeholder:
                                  _vm.$t("chatbotv2.parameterLabel") ||
                                  "Display label",
                              },
                              model: {
                                value: param.label,
                                callback: function ($$v) {
                                  _vm.$set(param, "label", $$v)
                                },
                                expression: "param.label",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "a-select",
                              {
                                staticStyle: { width: "150px" },
                                attrs: { disabled: _vm.isPublishedView },
                                model: {
                                  value: param.type,
                                  callback: function ($$v) {
                                    _vm.$set(param, "type", $$v)
                                  },
                                  expression: "param.type",
                                },
                              },
                              [
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "text" } },
                                  [_vm._v("Text")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "number" } },
                                  [_vm._v("Number")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "boolean" } },
                                  [_vm._v("Boolean")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "json" } },
                                  [_vm._v("Raw JSON")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "json-structured" } },
                                  [_vm._v("Structured JSON")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "array" } },
                                  [_vm._v("Array")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "userid" } },
                                  [_vm._v("User ID")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "userid_list" } },
                                  [_vm._v("User ID List")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "chatid" } },
                                  [_vm._v("Chat ID")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "contactid" } },
                                  [_vm._v("Contact ID")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-select",
                              {
                                staticStyle: { width: "120px" },
                                attrs: { disabled: _vm.isPublishedView },
                                model: {
                                  value: param.inputMode,
                                  callback: function ($$v) {
                                    _vm.$set(param, "inputMode", $$v)
                                  },
                                  expression: "param.inputMode",
                                },
                              },
                              [
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "static" } },
                                  [_vm._v("Static")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select-option",
                                  { attrs: { value: "dynamic" } },
                                  [_vm._v("Dynamic")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        param.type === "json-structured"
                          ? _c(
                              "div",
                              {
                                staticClass: "param-row",
                                staticStyle: {
                                  background: "#f0faff",
                                  padding: "10px",
                                  border: "1px solid #bae7ff",
                                  "border-radius": "4px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "structured-config",
                                    staticStyle: { width: "100%" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-between align-items-center mb-2",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-weight": "600",
                                              color: "#0050b3",
                                              display: "flex",
                                              "align-items": "center",
                                              gap: "5px",
                                            },
                                          },
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "cluster" },
                                            }),
                                            _vm._v(
                                              " Structured JSON Schema\n                                    "
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        !_vm.isPublishedView
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  gap: "8px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-button",
                                                  {
                                                    attrs: {
                                                      type: "primary",
                                                      size: "small",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.configureSchema(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          param.schema &&
                                                            param.schema.length
                                                            ? "JSON'dan Yeniden Oluştur"
                                                            : _vm.$t(
                                                                "chatbotv2.defineSchema"
                                                              )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                param.schema &&
                                                param.schema.length
                                                  ? _c(
                                                      "a-button",
                                                      {
                                                        attrs: {
                                                          type: "default",
                                                          size: "small",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.editSchemaDetails(
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("a-icon", {
                                                          attrs: {
                                                            type: "setting",
                                                          },
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "chatbotv2.detailedSettings"
                                                              )
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    param.schema && param.schema.length
                                      ? _c(
                                          "div",
                                          { staticClass: "schema-preview" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "font-size": "12px",
                                                  color: "#666",
                                                },
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v("Alanlar:"),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      param.schema
                                                        .map(function (f) {
                                                          return f.name
                                                        })
                                                        .join(", ")
                                                    ) +
                                                    "\n                                        "
                                                ),
                                                param.isList
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "ml-2" },
                                                      [
                                                        _c(
                                                          "a-tag",
                                                          {
                                                            attrs: {
                                                              color: "blue",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Liste (Array)"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "font-size": "12px",
                                              color: "#999",
                                              "font-style": "italic",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "chatbotv2.noStructureDefined"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "param-row" },
                          [
                            _c(
                              "a-input",
                              {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  disabled: _vm.isPublishedView,
                                  placeholder: _vm.$t("chatbotv2.defaultValue"),
                                },
                                model: {
                                  value: param.defaultValue,
                                  callback: function ($$v) {
                                    _vm.$set(param, "defaultValue", $$v)
                                  },
                                  expression: "param.defaultValue",
                                },
                              },
                              [
                                !_vm.isPublishedView
                                  ? _c(
                                      "a-button",
                                      {
                                        attrs: {
                                          slot: "addonAfter",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectSystemAttribute(
                                              index
                                            )
                                          },
                                        },
                                        slot: "addonAfter",
                                      },
                                      [
                                        _c("a-icon", {
                                          attrs: { type: "database" },
                                        }),
                                        _vm._v(
                                          "\n                                    System Attr\n                                "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-checkbox",
                              {
                                attrs: { disabled: _vm.isPublishedView },
                                model: {
                                  value: param.required,
                                  callback: function ($$v) {
                                    _vm.$set(param, "required", $$v)
                                  },
                                  expression: "param.required",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("chatbotv2.isRequired")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-checkbox",
                              {
                                attrs: { disabled: _vm.isPublishedView },
                                model: {
                                  value: param.hidden,
                                  callback: function ($$v) {
                                    _vm.$set(param, "hidden", $$v)
                                  },
                                  expression: "param.hidden",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("chatbotv2.hidden")))]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "param-row" },
                          [
                            _c("a-input", {
                              attrs: {
                                disabled: _vm.isPublishedView,
                                placeholder:
                                  _vm.$t("chatbotv2.parameterDescription") ||
                                  "Description (help text)",
                              },
                              model: {
                                value: param.description,
                                callback: function ($$v) {
                                  _vm.$set(param, "description", $$v)
                                },
                                expression: "param.description",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "section" },
                [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("chatbotv2.exampleOutput") || "Example Output"
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "section-description" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("chatbotv2.exampleOutputDesc")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("chatbotv2.outputSchemaJson") } },
                    [
                      _c("a-textarea", {
                        attrs: {
                          disabled: _vm.isPublishedView,
                          rows: 10,
                          placeholder: _vm.$t("chatbotv2.example"),
                        },
                        model: {
                          value: _vm.outputSchemaText,
                          callback: function ($$v) {
                            _vm.outputSchemaText = $$v
                          },
                          expression: "outputSchemaText",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-help" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("chatbotv2.outputSchemaHelp")) +
                            "\n                    "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "section" },
                [
                  _c("h3", [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.settings") || "Settings")),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-checkbox",
                        {
                          attrs: { disabled: _vm.isPublishedView },
                          model: {
                            value: _vm.formData.allowAutoUpdate,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "allowAutoUpdate", $$v)
                            },
                            expression: "formData.allowAutoUpdate",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("chatbotv2.allowAutoUpdate")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-help" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("chatbotv2.allowAutoUpdateHelp")) +
                            "\n                    "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("chatbotv2.visibility") } },
                    [
                      _c(
                        "a-select",
                        {
                          attrs: {
                            size: "large",
                            disabled: _vm.isPublishedView,
                          },
                          model: {
                            value: _vm.formData.visibility,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "visibility", $$v)
                            },
                            expression: "formData.visibility",
                          },
                        },
                        [
                          _c(
                            "a-select-option",
                            { attrs: { value: "public" } },
                            [
                              _c(
                                "span",
                                [
                                  _c("a-icon", { attrs: { type: "global" } }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("chatbotv2.publicEveryone"))
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-select-option",
                            { attrs: { value: "unlisted" } },
                            [
                              _c(
                                "span",
                                [
                                  _c("a-icon", { attrs: { type: "link" } }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("chatbotv2.unlistedLinkOnly")
                                      )
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-select-option",
                            { attrs: { value: "private" } },
                            [
                              _c(
                                "span",
                                [
                                  _c("a-icon", { attrs: { type: "lock" } }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("chatbotv2.privateSpecificSites")
                                      )
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formData.visibility === "private"
                    ? _c(
                        "a-form-item",
                        {
                          attrs: { label: _vm.$t("chatbotv2.allowedSiteIds") },
                        },
                        [
                          _c("a-select", {
                            attrs: {
                              mode: "tags",
                              size: "large",
                              disabled: _vm.isPublishedView,
                              placeholder: _vm.$t("chatbotv2.enterSiteIds"),
                            },
                            model: {
                              value: _vm.formData.allowedSiteIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "allowedSiteIds", $$v)
                              },
                              expression: "formData.allowedSiteIds",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "field-help" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("chatbotv2.allowedSiteIdsHelp")) +
                                "\n                    "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: _vm.$t("chatbotv2.importJsonSchema"), width: 700 },
          on: {
            ok: _vm.importJsonSchema,
            cancel: function ($event) {
              _vm.showJsonSchemaModal = false
            },
          },
          model: {
            value: _vm.showJsonSchemaModal,
            callback: function ($$v) {
              _vm.showJsonSchemaModal = $$v
            },
            expression: "showJsonSchemaModal",
          },
        },
        [
          _c(
            "div",
            { staticClass: "json-schema-import" },
            [
              _c("p", [
                _vm._v(_vm._s(_vm.$t("chatbotv2.importJsonSchemaDesc"))),
              ]),
              _vm._v(" "),
              _c("a-textarea", {
                attrs: { rows: 15, placeholder: _vm.$t("chatbotv2.example") },
                model: {
                  value: _vm.jsonSchemaInput,
                  callback: function ($$v) {
                    _vm.jsonSchemaInput = $$v
                  },
                  expression: "jsonSchemaInput",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "json-schema-help" }, [
                _c("strong", [_vm._v(_vm._s(_vm.$t("chatbotv2.tip")))]),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("chatbotv2.jsonSchemaTip")) +
                    "\n            "
                ),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("chatbotv2.systemAttributeSelect"),
            width: 600,
            footer: null,
          },
          model: {
            value: _vm.showSystemAttrModal,
            callback: function ($$v) {
              _vm.showSystemAttrModal = $$v
            },
            expression: "showSystemAttrModal",
          },
        },
        [
          _c(
            "div",
            { staticClass: "system-attr-selector" },
            [
              _c("a-input-search", {
                staticStyle: { "margin-bottom": "16px" },
                attrs: { placeholder: _vm.$t("chatbotv2.attributeSearch") },
                model: {
                  value: _vm.systemAttrSearch,
                  callback: function ($$v) {
                    _vm.systemAttrSearch = $$v
                  },
                  expression: "systemAttrSearch",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "attr-list" },
                _vm._l(_vm.filteredSystemAttributes, function (attr) {
                  return _c(
                    "div",
                    {
                      key: attr.value,
                      staticClass: "attr-item",
                      on: {
                        click: function ($event) {
                          return _vm.selectAttribute(attr)
                        },
                      },
                    },
                    [
                      _c("strong", [_vm._v(_vm._s(attr.name))]),
                      _vm._v(" "),
                      _c("code", {
                        domProps: {
                          textContent: _vm._s("{{ `${attr.value}` }}"),
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("chatbotv2.defineStructuredJsonSchema"),
            width: 700,
          },
          on: {
            ok: _vm.saveSchema,
            cancel: function ($event) {
              _vm.showSchemaModal = false
            },
          },
          model: {
            value: _vm.showSchemaModal,
            callback: function ($$v) {
              _vm.showSchemaModal = $$v
            },
            expression: "showSchemaModal",
          },
        },
        [
          _c(
            "div",
            { staticClass: "schema-builder" },
            [
              _c("p", [
                _vm._v(_vm._s(_vm.$t("chatbotv2.structuredJsonSchemaDesc"))),
              ]),
              _vm._v(" "),
              _c("a-textarea", {
                attrs: { rows: 10, placeholder: _vm.$t("chatbotv2.example") },
                model: {
                  value: _vm.schemaJsonInput,
                  callback: function ($$v) {
                    _vm.schemaJsonInput = $$v
                  },
                  expression: "schemaJsonInput",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-3" },
                [
                  _c("a-alert", { attrs: { type: "info", "show-icon": "" } }, [
                    _c("div", { attrs: { slot: "message" }, slot: "message" }, [
                      _vm._v("Nasıl Çalışır?"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "description" }, slot: "description" },
                      [
                        _vm._v(
                          '\n                        Buraya yapıştıracağınız örnek JSON analiz edilerek otomatik olarak form alanları oluşturulacaktır. \n                        Eğer bir liste (Array) yapıştırırsanız, parametre "Array of Objects" olarak işaretlenir ve kullanıcıdan çoklu kayıt girmesi istenir.\n                    '
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("chatbotv2.editStructuredJsonSchema"),
            width: 900,
          },
          on: {
            ok: _vm.saveSchemaDetails,
            cancel: function ($event) {
              _vm.showSchemaDetailModal = false
            },
          },
          model: {
            value: _vm.showSchemaDetailModal,
            callback: function ($$v) {
              _vm.showSchemaDetailModal = $$v
            },
            expression: "showSchemaDetailModal",
          },
        },
        [
          _c(
            "div",
            { staticClass: "schema-detail-editor" },
            [
              _c(
                "div",
                { staticClass: "schema-fields-list" },
                _vm._l(_vm.editingSchema, function (field, idx) {
                  return _c(
                    "div",
                    { key: idx, staticClass: "schema-field-item" },
                    [
                      _c(
                        "div",
                        { staticClass: "field-item-header" },
                        [
                          _c("span", { staticClass: "field-number" }, [
                            _vm._v("#" + _vm._s(idx + 1)),
                          ]),
                          _vm._v(" "),
                          _c("a-button", {
                            attrs: {
                              type: "danger",
                              size: "small",
                              icon: "delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeSchemaField(idx)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-row",
                        { staticClass: "mb-2", attrs: { gutter: 12 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.$t("chatbotv2.fieldName")) +
                                    " (Variable)"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("a-input", {
                                attrs: { placeholder: "fieldName" },
                                model: {
                                  value: field.name,
                                  callback: function ($$v) {
                                    _vm.$set(field, "name", $$v)
                                  },
                                  expression: "field.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("chatbotv2.displayName"))),
                              ]),
                              _vm._v(" "),
                              _c("a-input", {
                                attrs: { placeholder: "Field Label" },
                                model: {
                                  value: field.label,
                                  callback: function ($$v) {
                                    _vm.$set(field, "label", $$v)
                                  },
                                  expression: "field.label",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-row",
                        { staticClass: "mb-2", attrs: { gutter: 12 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("chatbotv2.type"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: field.type,
                                    callback: function ($$v) {
                                      _vm.$set(field, "type", $$v)
                                    },
                                    expression: "field.type",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "text" } },
                                    [_vm._v("Text")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "number" } },
                                    [_vm._v("Number")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "boolean" } },
                                    [_vm._v("Boolean")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "array" } },
                                    [_vm._v("Array")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "userid" } },
                                    [_vm._v("User ID")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "contactid" } },
                                    [_vm._v("Contact ID")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "chatid" } },
                                    [_vm._v("Chat ID")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.$t("chatbotv2.defaultValue"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-input",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "chatbotv2.defaultValue"
                                    ),
                                  },
                                  model: {
                                    value: field.defaultValue,
                                    callback: function ($$v) {
                                      _vm.$set(field, "defaultValue", $$v)
                                    },
                                    expression: "field.defaultValue",
                                  },
                                },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: {
                                        slot: "addonAfter",
                                        size: "small",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectSystemAttributeForField(
                                            idx
                                          )
                                        },
                                      },
                                      slot: "addonAfter",
                                    },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "database" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-row",
                        { staticClass: "mb-2", attrs: { gutter: 12 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 16 } },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("chatbotv2.description"))),
                              ]),
                              _vm._v(" "),
                              _c("a-input", {
                                attrs: { placeholder: "Field description" },
                                model: {
                                  value: field.description,
                                  callback: function ($$v) {
                                    _vm.$set(field, "description", $$v)
                                  },
                                  expression: "field.description",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("a-col", { attrs: { span: 8 } }, [
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("chatbotv2.settings"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "a-checkbox",
                                  {
                                    model: {
                                      value: field.required,
                                      callback: function ($$v) {
                                        _vm.$set(field, "required", $$v)
                                      },
                                      expression: "field.required",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("chatbotv2.isRequired"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-checkbox",
                                  {
                                    staticClass: "ml-2",
                                    model: {
                                      value: field.hidden,
                                      callback: function ($$v) {
                                        _vm.$set(field, "hidden", $$v)
                                      },
                                      expression: "field.hidden",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("chatbotv2.hidden")))]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticClass: "mt-3",
                  attrs: { type: "dashed", block: "", icon: "plus" },
                  on: { click: _vm.addSchemaField },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("chatbotv2.newFieldAdd")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("chatbotv2.javascriptAssistant"),
            width: 800,
            footer: null,
          },
          on: { cancel: _vm.handleAssistantClose },
          model: {
            value: _vm.showJsAssistant,
            callback: function ($$v) {
              _vm.showJsAssistant = $$v
            },
            expression: "showJsAssistant",
          },
        },
        [
          _c("div", { staticClass: "js-assistant-modal" }, [
            _c("div", { staticClass: "js-assistant-description" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("chatbotv2.aiWizard")))]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("chatbotv2.aiWizardDesc")) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "js-capabilities" }, [
                _c(
                  "div",
                  { staticClass: "capabilities-header" },
                  [
                    _c("a-icon", { attrs: { type: "bulb" } }),
                    _vm._v(" "),
                    _c("h5", [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.youCanDo")) + ":"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "capabilities-content" }, [
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("chat"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.sendingMessage"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("transfer_within_a_station"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.chatTransfer"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.chatClosing"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("http"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.apiRequests"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("person"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.contactOperations"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "capability-item" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("settings"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.attributeUpdating"))),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "prompt-container" },
              [
                _c("s2-textarea", {
                  ref: "promptTextarea",
                  attrs: {
                    rows: 4,
                    placeholder: _vm.$t("chatbotv2.aiWizardExample"),
                  },
                  model: {
                    value: _vm.jsPrompt,
                    callback: function ($$v) {
                      _vm.jsPrompt = $$v
                    },
                    expression: "jsPrompt",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "example-prompts" }, [
                  _c(
                    "div",
                    {
                      staticClass: "example-prompt",
                      on: {
                        click: function ($event) {
                          _vm.selectExamplePrompt(
                            _vm.$t("chatbotv2.examplePrompt1")
                          )
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "api" } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.examplePrompt1"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "example-prompt",
                      on: {
                        click: function ($event) {
                          _vm.selectExamplePrompt(
                            _vm.$t("chatbotv2.examplePrompt2")
                          )
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "check-circle" } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.examplePrompt2"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "example-prompt",
                      on: {
                        click: function ($event) {
                          _vm.selectExamplePrompt(
                            _vm.$t("chatbotv2.examplePrompt3")
                          )
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "code" } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.examplePrompt3"))),
                      ]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "buttons-container" },
                  [
                    _c(
                      "a-button",
                      { on: { click: _vm.handleAssistantClose } },
                      [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: {
                          type: "primary",
                          loading: _vm.assistantLoading,
                        },
                        on: { click: _vm.generateJavaScriptCode },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("chatbotv2.generateCode")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.showChangelogModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("chatbotv2.publishBlock") || "Publish Block",
                description:
                  _vm.$t("chatbotv2.enterChangelog") ||
                  "Enter changelog (optional)",
                okText: _vm.$t("chatbotv2.publish") || "Publish",
                cancelText: _vm.$t("message.cancel") || "Cancel",
              },
              on: {
                ok: _vm.confirmPublish,
                cancel: function ($event) {
                  _vm.showChangelogModal = false
                },
              },
            },
            [
              _c("a-textarea", {
                attrs: {
                  rows: 5,
                  placeholder:
                    _vm.$t("chatbotv2.changelogPlaceholder") ||
                    "Describe the changes made in this version...",
                },
                model: {
                  value: _vm.changelogInput,
                  callback: function ($$v) {
                    _vm.changelogInput = $$v
                  },
                  expression: "changelogInput",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }